import { defineMessages } from 'react-intl';

const pageItems = defineMessages({
    title: {
        id: 'arrivalTime.pageItems.title',
        defaultMessage: 'Arrival Time',
    },
    
});

const buttons = defineMessages({
    continue: {
        id: 'arrivalTime.buttons.continue',
        defaultMessage: 'Save & Continue',
    },
});

const form = defineMessages({
    formTitle: {
        id: 'arrivalTime.form.title',
        defaultMessage: 'Expected Arrival Details',
    },
    pickUpBranch: {
        id: 'arrivalTime.form.pickUpBranch',
        defaultMessage: 'Pick Up Branch:',
    },
    operatingHours: {
        id: 'arrivalTime.form.operatingHours',
        defaultMessage: 'Operating Hours ({date}):',
    },
    branchArrivalTime: {
        id: 'arrivalTime.form.branchArrivalTime',
        defaultMessage: 'Branch Arrival Time',
    },
    flightNumber: {
        id: 'arrivalTime.form.flightNumber',
        defaultMessage: 'Flight Number',
    },
    placeholder: {
        id: 'arrivalTime.form.flightNumberPlaceHolder',
        defaultMessage: 'Enter your flight number...',
    },
});

const formError = defineMessages({
    operatingHours: {
        id: 'arrivalTime.formError.operatingHours',
        defaultMessage: 'Arrival time must be within operatingHours',
    }, 
});

const label = defineMessages({
    branchArrivalTime: {
        id: 'arrivalTime.label.branchArrivalTime',
        defaultMessage: 'Free',
    },
    flightNumber: {
        id: 'arrivalTime.label.flightNumber',
        defaultMessage: 'Full',
    },
});

const arrivalTimeMessages = {
    pageItems,
    buttons,
    form,
    formError,
    label,
};

export default arrivalTimeMessages;
